import React from "react";
import AbstractExtranetRegisterStepper from "../../../../stepper/AbstractExtranetRegisterStepper";
import FormStepperContainer from "../../../../stepper/FormStepperContainer";
import FormBlocContainer from "../../../../layout/form/FormBlocContainer";
import NumSSBloc from "../../../../layout/surface/recap/NumSSBloc";
import KeySSBloc from "../../../../layout/surface/recap/KeySSBloc";
import FullnameBloc from "../../../../layout/surface/recap/FullnameBloc";
import BirthdateBloc from "../../../../layout/surface/recap/BirthdateBloc";
import EmailBloc from "../../../../layout/surface/recap/EmailBloc";
import '../../../../../styles/recapitulatif.scss';
import DOMHelper from "../../../../../helpers/DOMHelper";
import InsuredRegistrationService from "../../../../../api/extranet/services/InsuredRegistrationService";
import StringHelper from "../../../../../helpers/StringHelper";
import SweetAlert from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Grid, Table, TableBody, TableContainer } from "@mui/material";
import SubCard from '../../../../berry/ui-component/cards/SubCard';
import PathManager from "../../../../../helpers/PathManager";
import Loader from "../../../../berry/ui-component/Loader";

const ReactSweetAlert = withReactContent(SweetAlert);

class ValidationStep extends AbstractExtranetRegisterStepper {

    state = {
        ...this.props.data,
        loading: false,
    }

    constructor(props) {
        super(props);
        this.mainForm = React.createRef();
        this.pathManager = new PathManager(this.props.history)
    }


    callCreateInsuredAccount = async () => {

        const {
            firstname,
            lastname,
            email,
            ssNum,
            ssKey,
            password,
            insuredData
        } = this.state;

        this.setState({ loading: true });

        const resultCreateInsuredAccount = await InsuredRegistrationService.createInsuredAccount(email,
            lastname,firstname,StringHelper.unformatSSNum(ssNum), ssKey, password,insuredData);

        this.setState({ loading: false });
        return resultCreateInsuredAccount;
    }

    handleRedirectContactForm = (event) => {
        event.stopPropagation();
        const data = {
            lastname: this.state.lastname,
            birthdate: this.state.birthdate,
            ssNum: this.state.ssNum
        }
        this.pathManager.goTo('contact-insured', '', data);
        SweetAlert.close();
    }

    handleValidation = () => {

        this.mainForm.current.isFormValid(false)
            .then(async (value) => {
                if (value) {
                    const resultCreateInsuredAccount = await this.callCreateInsuredAccount();
                    if (resultCreateInsuredAccount.code === 201) {

                        // Redirect to inform the user to verify his email
                        this.pathManager.goTo('inform-verify-email','', { email: this.state.email, linkDuration: 7 })

                    } else {

                        // show error
                        await ReactSweetAlert.fire({
                            title: 'Oups !',
                            html: <p>
                                {resultCreateInsuredAccount.message}
                                <br />
                                <br />
                                Si vous rencontrez des difficultés alors que vous bénéficiez bien de nos prestations, vous pouvez nous contacter en cliquant&nbsp;
                                <a href="#" onClick={this.handleRedirectContactForm}>ici</a>
                            </p>,
                            type: 'error',
                            confirmButtonText: 'Fermer',
                            confirmButtonColor: "#EF595D"
                        });

                    }
                } else {
                    DOMHelper.scrollToError();
                }
            })
        ;
    }

    render() {
        return <FormStepperContainer
            ref={this.mainForm}
            label={"Synthèse et validation"}
            activeStep={this.props.activeStep}
            nbStep={this.props.nbStep}
            id={this.state.id}
            handleBack={this.handleBackHistory}
            handleNext={this.handleValidation}
        >
            {this.state.loading && <Loader />}
            <FormBlocContainer className={"recap"}>
                <Grid container spacing={2}>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={12} md={5}>
                        <SubCard title="Informations personnelles">
                            <TableContainer>
                                <Table sx={{ '& td': { borderBottom: 'none' } }} size="small">
                                    <TableBody>
                                        <FullnameBloc firstname={this.state.firstname} lastname={this.state.lastname} label={"Assuré"} xs={12} sm={6} />
                                        <BirthdateBloc birthdate={this.state.birthdate} xs={12} sm={6} />
                                        <EmailBloc email={this.state.email} xs={12} sm={6} />
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </SubCard>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <SubCard title="">
                            <TableContainer>
                                <Table sx={{ '& td': { borderBottom: 'none' } }} size="small">
                                    <TableBody>
                                        <NumSSBloc numSS={this.state.ssNum} xs={12} sm={6} />
                                        <KeySSBloc keySS={this.state.ssKey} xs={12} sm={6} />
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </SubCard>
                    </Grid>
                    <Grid item xs={0} sm={1}></Grid>
                </Grid>
                <Grid item xs={0} sm={1}></Grid>
            </FormBlocContainer>
        </FormStepperContainer>
    }

}

/*
const ValidationStep = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const mainForm = useRef();

    const [state, setState] = useState({
        ...props.data
    });

    const callCreateInsuredAccount = async () => {
        const { firstname, lastname, email, ssNum, ssKey, password, insuredData } = state;
        dispatch(toggleLoading());

        const resultCreateInsuredAccount = await InsuredRegistrationService.createInsuredAccount(
            email, lastname, firstname, StringHelper.unformatSSNum(ssNum), ssKey, password, insuredData);

        dispatch(toggleLoading());
        return resultCreateInsuredAccount;
    }

    const handleRedirectContactForm = (event) => {
        event.stopPropagation();
        const data = {
            lastname: state.lastname,
            birthdate: state.birthdate,
            ssNum: state.ssNum
        };

        history.push('/ui/contact/insured', { state: data });
        SweetAlert.close();
    }

    const handleValidation = () => {
        mainForm.current.isFormValid(false)
            .then(async (value) => {
                if (value) {
                    const resultCreateInsuredAccount = await callCreateInsuredAccount();
                    if (resultCreateInsuredAccount.code === 201) {
                        history.push('/ui/inform-verify-email', { state: { email: state.email, linkDuration: 7 } });
                    } else {
                        await ReactSweetAlert.fire({
                            title: 'Oups !',html: (
                                <p>
                                    {resultCreateInsuredAccount.message}
                                    <br />
                                    <br />
                                    Si vous rencontrez des difficultés alors que vous bénéficiez bien de nos prestations, vous pouvez nous contacter en cliquant&nbsp;
                                    <a href="#" onClick={handleRedirectContactForm}>ici</a>
                                </p>
                            ),
                            icon: 'error',
                            confirmButtonText: 'Fermer',
                            confirmButtonColor: '#EF595D'
                        });
                    }
                } else {
                    DOMHelper.scrollToError();
                }
            });
    }

    return (
        <FormStepperContainer
            ref={mainForm}
            label={"Synthèse et validation"}
            activeStep={props.activeStep}
            nbStep={props.nbStep}
            id={state.id}
            handleBack={props.handleBackHistory}
            handleNext={handleValidation}
        >
            <FormBlocContainer className={"recap"}>
                <Grid container spacing={2}>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={12} md={5}>
                        <SubCard title="Informations personnelles">
                            <TableContainer>
                                <Table sx={{ '& td': { borderBottom: 'none' } }} size="small">
                                    <TableBody>
                                        <FullnameBloc firstname={state.firstname} lastname={state.lastname} label={"Assuré"} xs={12} sm={6} />
                                        <BirthdateBloc birthdate={state.birthdate} xs={12} sm={6} />
                                        <EmailBloc email={state.email} xs={12} sm={6} />
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </SubCard>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <SubCard title="Les informations recueillies par">
                            <TableContainer>
                                <Table sx={{ '& td': { borderBottom: 'none' } }} size="small">
                                    <TableBody>
                                        <NumSSBloc numSS={state.ssNum} xs={12} sm={6} />
                                        <KeySSBloc keySS={state.ssKey} xs={12} sm={6} />
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </SubCard>
                    </Grid>
                    <Grid item xs={0} sm={1}></Grid>
                </Grid>
                <Grid item xs={0} sm={1}></Grid>
            </FormBlocContainer>
        </FormStepperContainer>
    );
}*/

export default ValidationStep;
